import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { E_KEY_FEATURE_GUIDE_TYPE } from '../enums';
let UserGuideApiDtoImpl = class UserGuideApiDtoImpl {
    formateGuideData(status) {
        return {
            [E_KEY_FEATURE_GUIDE_TYPE.AUTO_UPDATE]: status,
            [E_KEY_FEATURE_GUIDE_TYPE.AI_TAGGING]: status,
            [E_KEY_FEATURE_GUIDE_TYPE.SHARE]: status,
        };
    }
};
UserGuideApiDtoImpl = __decorate([
    injectable()
], UserGuideApiDtoImpl);
export { UserGuideApiDtoImpl };
